"use client";

import * as React from "react";
import { Star, Quote } from "lucide-react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  id: 1,
  name: "Michael T.",
  service: "Refrigerator Repair Match",
  text: "Our fridge stopped cooling right before the weekend. We submitted a request and connected with a local technician who arrived promptly, diagnosed a bad compressor relay, and had it running quickly. Great experience with the pro.",
  initials: "MT"
}, {
  id: 2,
  name: "Sarah Jenkins",
  service: "Washing Machine Repair Match",
  text: "I was worried I would need a whole new washer when water began leaking on the floor. The repair pro gave a straightforward quote, showed me the cracked tub seal, and replaced the part cleanly.",
  initials: "SJ"
}, {
  id: 3,
  name: "David R.",
  service: "Oven & Stove Repair Match",
  text: "The bake element in our oven failed. Booking through Handy Heroes was simple, and the contractor was polite, tested the circuit, and brought the replacement part needed to get our oven heating again.",
  initials: "DR"
}];
export default function ApplianceTestimonials() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="appliancerepairtestimonials" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`flex flex-col items-center text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground sm:text-4xl">
            Homeowner Experiences
          </h2>
          <p className="mt-4 max-w-2xl text-lg text-muted-foreground">
            Read what Atlanta homeowners say about getting matched with independent local appliance repair pros through Handy Heroes.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-8 md:grid-cols-3">
          {testimonials.map((testimonial, i) => <div key={testimonial.id} data-index={i} className={`transition-all duration-700 ease-out delay-${i * 150} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <Card className="h-full flex flex-col relative border-border/50 shadow-sm hover:shadow-md transition-shadow duration-300">
                <div className="absolute -top-4 right-6 bg-primary/10 p-2 rounded-lg text-primary">
                  <Quote className="size-5" />
                </div>
                <CardHeader className="pb-4">
                  <div className="flex items-center gap-4">
                    <div className="flex size-12 shrink-0 items-center justify-center rounded-lg bg-secondary text-secondary-foreground font-default font-semibold text-lg">
                      {testimonial.initials}
                    </div>
                    <div>
                      <h3 className="font-default font-semibold text-foreground">
                        {testimonial.name}
                      </h3>
                      <p className="text-sm text-muted-foreground">
                        {testimonial.service}
                      </p>
                    </div>
                  </div>
                </CardHeader>
                <CardContent className="flex-1 flex flex-col gap-4">
                  <div className="flex items-center gap-1 text-xs text-primary font-medium">
                    Verified Customer Feedback
                  </div>
                  <p className="text-muted-foreground leading-relaxed">
                    "{testimonial.text}"
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}